import styled, { css } from "styled-components"

export const LeftBox = styled.div`
  flex: 1;
  display: flex;
  justify-content: left;
`
